import moment from 'moment';
import { CRFDetails, StudyLegendsInfo, SubjectVisit } from 'src/types/SubjectCalenderVisits';

export function getSubjectVisitsCalendarEvents(subjectVistsData: any): any {
  const subjectsList: string[] = [];
  const allCalendarVisits: any[] = [];
  const visitsLegendsInfo: StudyLegendsInfo[] = [];
  const visitsCRFsInfo: any[] = [];

  subjectVistsData.subject_visit_details.forEach((subjectVisitDetails: any) => {
    subjectsList.push(subjectVisitDetails.subject.subject_id);
    if (subjectVisitDetails.visits.length > 0) {
      subjectVisitDetails.visits.forEach((eachVisit: SubjectVisit) => {
        if (visitsLegendsInfo.length === 0) {
          visitsLegendsInfo.push({
            visit_name: eachVisit.protocol_visit_name,
            visit_color: eachVisit.visit_color,
            visit_id: eachVisit.visit_id
          });
        } else if (
          !visitsLegendsInfo.some((visitLegend: StudyLegendsInfo) => visitLegend.visit_id === eachVisit.visit_id)
        ) {
          visitsLegendsInfo.push({
            visit_name: eachVisit.protocol_visit_name,
            visit_color: eachVisit.visit_color,
            visit_id: eachVisit.visit_id
          });
        }
        allCalendarVisits.push({
          ...eachVisit,
          crf_activated: subjectVisitDetails.subject.crf_activated,
          subject_id: subjectVisitDetails.subject.subject_id,
          start: new Date(`${eachVisit.start_on}Z`),
          end: moment(`${eachVisit?.start_on}Z`).add(eachVisit?.duration, 'minutes'),
          title: `${subjectVisitDetails.subject.subject_id} - ${
            eachVisit?.unscheduled_visit_name !== null
              ? eachVisit?.unscheduled_visit_name
              : eachVisit.protocol_visit_name
          }`,
          assessments:
            eachVisit.crfs.length > 0
              ? eachVisit.crfs.map((crf: CRFDetails) => (crf.custom_name ? crf.custom_name : crf.crf_OID)).join(', ')
              : ''
        });
        eachVisit.crfs?.forEach((ele: any) => {
          visitsCRFsInfo.push(ele);
        });
      });
    }
  });
  return { subjectsList, allCalendarVisits, visitsLegendsInfo, visitsCRFsInfo };
}

export function getSelectedSubjectVisitCalenderEvents(selectedSubjectId: string | null, subjectsVisitData: any): any {
  const allCalendarVisits: any[] = [];
  let selectedSubjectObj: any = {};

  const selectedSubjectVisitInfo = subjectsVisitData.subject_visit_details
    ? subjectsVisitData.subject_visit_details.find(
        (subjectVisitDetails: any) => subjectVisitDetails.subject.subject_id === selectedSubjectId
      )
    : [];

  if (selectedSubjectVisitInfo.visits.length > 0) {
    selectedSubjectObj = selectedSubjectVisitInfo[0];
    selectedSubjectVisitInfo.visits.forEach((eachVisit: SubjectVisit) => {
      allCalendarVisits.push({
        ...eachVisit,
        subject_id: selectedSubjectVisitInfo.subject.subject_id,
        start: new Date(`${eachVisit.start_on}Z`),
        end: moment(`${eachVisit?.start_on}Z`).add(eachVisit?.duration, 'minutes'),
        title: `${moment(`${eachVisit.start_on}Z`).format('LT')} - ${
          eachVisit?.unscheduled_visit_name !== null ? eachVisit?.unscheduled_visit_name : eachVisit.protocol_visit_name
        }`,
        assessments:
          eachVisit.crfs.length > 0
            ? eachVisit.crfs.map((crf: CRFDetails) => (crf.custom_name ? crf.custom_name : crf.crf_OID)).join(', ')
            : ''
      });
    });
  }
  return { allCalendarVisits, selectedSubjectObj };
}
